export default {"src":"/_next/static/media/bankTransfer.7176cacc.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};